import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import HomeSectionBanners from '../admin/pages/HomeSectionBanners';
import HeroBannersManager from '../admin/pages/HeroBannersManager';
import ContentPopularDestinationsPage from './ContentPopularDestinationsPage';

export default function ContentBannersPage({ token }) {
  const [activeTab, setActiveTab] = useState('hero');

  return (
    <div className="p-4 bg-white rounded shadow-sm">
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-3">
        <div>
          <h4 className="mb-0">Banner Management</h4>
          <small className="text-muted">Hero Banners and Slider &amp; Section Banners.</small>
        </div>
      </div>
      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'hero')}>
        <Tab eventKey="hero" title="Hero Banners">
          <HeroBannersManager token={token} />
        </Tab>
        <Tab eventKey="sections" title="Slider & Section Banners">
          <HomeSectionBanners token={token} />
        </Tab>
        <Tab eventKey="destinations" title="Popular Destinations">
          <ContentPopularDestinationsPage token={token} />
        </Tab>
      </Tabs>
    </div>
  );
}
